import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8,
    marginTop: 10,
    marginBottom: 16
  },
  hotelDataAndReserveData: {
    width: '100%',
    flexDirection: 'row'
  },
  header: {
    alignItems: 'center'
  },
  QRCodePart: {
    width: '25%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  reserveData: {
    width: '75%'
  },
  priceAndName: {
    width: '100%'
  },
  hotelDetail: {
    width: '100%'
  }
})
export default styles
